import styled from '@emotion/styled'

import Icon from '~/shared/atoms/Icon'

export const TooltipWrapper = styled.div`
  margin: 0.5rem 0;
  align-self: end;
  pointer-events: none;
`

export const MenuIconWrapper = styled.div<{ iconSize: string }>`
  position: relative;
  pointer-events: auto;
  grid-area: menu;
  width: ${({ iconSize }) => iconSize};
  height: ${({ iconSize }) => iconSize};

  &::after {
    content: '';
    position: absolute;
    width: calc(${({ iconSize }) => iconSize} * 3);
    height: calc(${({ iconSize }) => iconSize} * 3);
    top: calc(${({ iconSize }) => iconSize} * -1);
    left: calc(${({ iconSize }) => iconSize} * -1);
  }
`

export const MenuIcon = styled(Icon)<{ iconSize: string }>`
  display: block;
  width: ${({ iconSize }) => iconSize};
  height: fit-content;
  color: ${({ theme }) => theme.colors.gray[900]};
`
